<div #main class="ad-doc-viewer-container">
    <virtual-scroller #scroll [hidden]="loading" [style.height]="viewportHight" [items]="items"
        [bufferAmount]="bufferAmount">
        <div class="ad-doc-viewer-img" [style.width.px]="itemWidth*zoom" *ngFor="let item of scroll.viewPortItems">
            <img [src]="item.img" alt="">
        </div>
    </virtual-scroller>
    <div class="ad-doc-viewer-loading" [hidden]="!loading">
        <div>
            <div class="ad-doc-viewer-loading-title">Preparing document for viewing...</div>
            <ad-skeleton count="1"></ad-skeleton>
        </div>
    </div>

</div>